<template>
  <div>
    <div class="app-title">
      <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section v-menu-permission="'list'" class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div id="collapseOne" aria-labelledby="headingOne" class="collapse show"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter ref="emListFilter" :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                           :entity="modelName"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="sithMesInventoryPackageMaterialResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" aria-labelledby="headingTwo" class="collapse show"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table ref="emTable"
                        :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                        :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                        :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                        :entity="modelName" :inlineActionsDisabled="prop_inline!=='1'"
                        @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"
                        @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow">

                <template #left-header>
                  <em-button :disabled="actionDisabled('select')" :showName="true"
                             custom-icon="fa fa-fw fa-lg fa-file-excel"
                             custom-label="生成出门证"
                             type="edit"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             @click="generateExitPermission()"
                  >
                  </em-button>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
  </div>
</template>
<script>
// Author Lin
// Date 2021-06-28 10:31:33

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";

export default {
  name: "sithMesInventoryPackageMaterialListView",
  mixins: [emCommonListMixin, emCustomVuexMixin],
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0"
    },
    $_emCustomVuexMixin_vo: {
      type: String,
      default: 'packageVo'
    },
    $_emCustomVuexMixin_filter: {
      type: String,
      default: 'packageFilter'
    },
    customVuexName: {
      type: String,
    }
  },
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName
    },
    checkedItems() {
      //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
      return this.$store.state[this.modelName]["checkedItems"];
    },
    selectIds() {
      //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
      return this.$store.state[this.modelName]["checkedItems"].join(",");
    },
  },
  mounted() {
      this.$store.commit('commonList/setCustomVuexName', 'package');
      this.$refs["emListFilter"].doQuery();
  },
  methods: {
    actionDisabled(type) {
      // 删除按钮在一条记录都没选的时候禁用
      if (type === "select") {
        return this.checkedItems && this.checkedItems.length === 0;
      }
      // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
      else if (type === "selectOne") {
        return this.checkedItems && this.checkedItems.length !== 1;
      }
    },
    //生成出门证
    generateExitPermission() {

    }
  },
};
</script>